const mediaItems = [
  {
    img: "https://readdy.ai/api/search-image?query=Cinematic%20drama%20series%20poster%20style%20with%20warm%20golden%20lighting%2C%20two%20characters%20in%20traditional%20Chinese%20costume%20facing%20each%20other%20in%20ancient%20palace%20setting%2C%20soft%20atmospheric%20mist%2C%20film%20grain%20texture%2C%20professional%20drama%20series%20key%20visual%2C%20warm%20amber%20and%20crimson%20color%20palette&width=800&height=450&seq=media-show-01&orientation=landscape",
    tag: '古装传奇',
    title: '长安风云录',
    desc: '大唐盛世权谋大戏，口碑爆棚古装巨制',
  },
  {
    img: "https://readdy.ai/api/search-image?query=Modern%20urban%20romance%20drama%20visual%20with%20couple%20walking%20in%20city%20street%20at%20sunset%2C%20warm%20golden%20hour%20lighting%2C%20film%20grain%20texture%2C%20professional%20drama%20series%20aesthetic%2C%20soft%20romantic%20mood%2C%20clean%20modern%20composition&width=800&height=450&seq=media-show-02&orientation=landscape",
    tag: '都市情感',
    title: '遇见你的那天',
    desc: '都市男女暖心情感故事，高甜治愈口碑之作',
  },
  {
    img: "https://readdy.ai/api/search-image?query=Suspense%20thriller%20drama%20visual%20with%20detective%20character%20in%20dark%20alley%2C%20neon%20light%20reflections%2C%20mysterious%20atmosphere%2C%20film%20noir%20aesthetic%2C%20professional%20crime%20drama%20key%20visual%2C%20moody%20blue%20and%20warm%20accent%20lighting&width=800&height=450&seq=media-show-03&orientation=landscape",
    tag: '悬疑刑侦',
    title: '迷雾追踪',
    desc: '烧脑悬疑全程高能，年度最佳刑侦剧集',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">精选推荐</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            编辑团队每日精选高分好剧，为您推荐不可错过的精彩内容
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {mediaItems.map((item) => (
            <div key={item.title} className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer">
              <div className="relative aspect-video overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-background-950/60 flex items-center justify-center backdrop-blur-sm group-hover:bg-primary-500/80 transition-colors duration-300">
                    <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-background-950/70 text-background-50 text-xs font-medium backdrop-blur-sm">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-base font-semibold text-foreground-950 font-heading mb-1.5">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}